<template>
  <div class="page">
    <!-- <div class="topBox">
      <div class="secondBar">
        <div class="sheetInfo">
          <t-button @click="choseDate(0)" variant="text">{{ startDate }}</t-button>
          <t-icon name="arrow-down" color="gray" />
          <text class="txtSpan">至</text>
          <t-button @click="choseDate(1)" variant="text">{{ endDate }}</t-button>
          <t-icon name="arrow-down" size="42rpx" />
        </div>

        <div class="sheetInfo">

        </div>
      </div>
    </div> -->

    <div v-if="orderList.length === 0 && isOver">
      <div class="imgBox">
        <image src="https://img01.yzcdn.cn/vant/empty-image-search.png"></image>
      </div>
      <div class="emptyInfo">暂无订单</div>
    </div>

    <div class="mainBox">
      <order-item v-for="(item, index) in orderList" :key="item._id || index" :order="item" @click="choseThis(item)" />
    </div>
  </div>

  <t-popup v-model:visible="showDatePicker" placement="bottom">
    <t-date-time-picker :value="editDate" :mode="['date']" title="选择时间" format="YYYY-MM-DD" @confirm="onDateConfirm"
      @cancel="showDatePicker = false" />
  </t-popup>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits, getCurrentInstance } from 'vue'
import { Toast } from 'tdesign-mobile-vue'
import orderItem from './order-item.vue'
import { stateShop } from '@/store'
const { proxy } = getCurrentInstance();

const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase

// 定义 props
const props = defineProps({
  customerId: {
    type: String,
    default: ''
  },
})

// 定义 emits
const emit = defineEmits(['choseOrder'])

// 响应式数据
const isOver = ref(false)
const showDatePicker = ref(false)
const editDate = ref(new Date())
const editDateType = ref(0)
const startDate = ref('')
const endDate = ref('')
const pageIndex = ref(1)
const orderList = ref([])


// 方法
const choseThis = (item) => {
  emit('choseOrder', item.productList)
}

// const choseDate = (type) => {
//   showDatePicker.value = true
//   editDateType.value = type
//   editDate.value = type === 0 ? startDate.value : endDate.value
// }

// 日期选择器变更处理
const onDateConfirm = (value) => {
  if (editDateType.value === 0) {
    startDate.value = value
  } else {
    endDate.value = value
  }
  showDatePicker.value = false
  resetAndReload()
}



const resetAndReload = () => {
  isOver.value = false
  pageIndex.value = 1
  orderList.value = []
  loadOrderList()
}

const loadOrderList = async () => {
  if (isOver.value) {
    Toast('没有更多')
    return
  }

  try {

    const db = app.database()
    const _ = db.command

    let queryData = {
      'status': _.gt(0),
      shopId: stateShop._id
    }

    if (props.customerId) {
      queryData['customer._id'] = props.customerId
    }

    // if (startDate.value && endDate.value) {
    //   queryData['createAt.time3'] = _.and(
    //     _.gte(startDate.value),
    //     _.lte(endDate.value)
    //   )
    // }

    const _pageSize = 20
    const _skipNum = (pageIndex.value - 1) * _pageSize

    const res = await db.collection("my_order")
      .where(queryData)
      .orderBy('createAt.timeStamp', 'desc')
      .skip(_skipNum)
      .limit(_pageSize)
      .get()

    console.log(res.data, 'res.data')

    if (res.data.length < _pageSize) {
      isOver.value = true
    }

    pageIndex.value++
    orderList.value = [...orderList.value, ...res.data]
  } catch (error) {
    console.error('加载订单失败:', error)
    Toast('加载失败')
  }
}

// 初始化日期
const initDate = () => {
  const today = new Date()
  const lastMonth = new Date()
  lastMonth.setMonth(lastMonth.getMonth() - 1)

  startDate.value = lastMonth.toISOString().split('T')[0]
  endDate.value = today.toISOString().split('T')[0]
}

// 生命周期
onMounted(() => {
  console.log('订单列表加载')
  initDate()
  loadOrderList()
})
</script>

<style scoped>
.page {

  background-color: #f6f6f6;
  height: 70vh;
  padding-bottom: 3vw;
}

.imgBox image {
  width: 40vw;
  height: 40vw;
}

.mainBox {
 
  overflow-y: auto;
  height: calc(70vh - 3vw);
}

.topBox {
  height: 10vw;
  z-index: 10;
  position: fixed;
  width: 90vw;
  padding: 0 5vw;
  background-color: #f6f6f6;
}

.secondBar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5vw;
}

.sheetInfo {
  padding-top: 2vw;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
}

.sheetInfo .txtSpan {
  padding: 0 1vw;
}

.imgBox {
  margin-top: 15vw;
  padding: 12vw;
  display: flex;
  justify-content: center;
}

.emptyInfo {
  color: gray;
  text-align: center;
}
</style>